import {
  appStoreLinkClicked,
  signUpClicked,
  upgradeCtaClicked,
  upgradeDiscountPlanLinkClicked,
  viewPlansClicked,
} from './actions';
import * as D from './deps';
import GtmWatchers from './sagas/watchers';

export default D.createDomainModule({
  name: 'googleTagManager',
  actions: {
    _gtm_: {
      signUpClicked,
      viewPlansClicked,
      appStoreLinkClicked,
      upgradeCtaClicked,
      upgradeDiscountPlanLinkClicked,
    },
  },
  onStart() {
    this.registeredHandlers = D.registerHandlers(GtmWatchers);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
